import React, { useState } from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { FxGuard } from "@coralblack/flax";
import { usePreScreeningSiteContext } from "@layouts/home/PreScreeningSiteContext";
import { Main } from "@layouts/Main";
import { useEcoaBreadcrumb } from "@hooks/useEcoaBreadcrumb";
import { StudyEcoaConfigSpec } from "maven-lib/dist/consts/edc/crf";
import { StudyCaptureData } from "maven-lib/dist/dto/entity/studyCapture";
import { ecoaConfigApi } from "maven-lib/dist/states/apis/ecoaConfig";
import { Identification } from "./preprocess/Identification";
import { PreScreening } from "./preprocess/PreScreening";
import { Privacy } from "./preprocess/Privacy";

interface PreProcessProps {
  studyId: bigint;
}

interface PreProcessInnerProps extends PreProcessProps {
  config: StudyEcoaConfigSpec;
}

export function PreProcess(props: PreProcessProps) {
  const { studyId } = props;

  const { selectedSite } = usePreScreeningSiteContext();

  return (
    <FxGuard
      api={{
        ...ecoaConfigApi.getEcoaConfig(studyId),
        query: selectedSite
          ? {
              site_id: selectedSite.id,
            }
          : undefined,
      }}
      render={(resp) => {
        if (resp?.config) return <PreProcessInner config={resp.config!} studyId={studyId} />;
        else return <Redirect to={`/${studyId}/recruit`} />;
      }}
    />
  );
}

function PreProcessInner({ config, studyId }: PreProcessInnerProps) {
  const match = useRouteMatch();
  const { header, footer } = useEcoaBreadcrumb();

  const [encryptedPayload, setEncryptedPayload] = useState<string>("");
  const [savedData, setSavedData] = useState<Array<StudyCaptureData>>([]);

  const handleSaveData = (data: Array<StudyCaptureData>) => {
    setSavedData((prev) => [...prev, ...data]);
  };

  const saveEncryptedPayload = (encryptedPayload: string) => {
    setEncryptedPayload(encryptedPayload);
  };

  const getPreProcessData = () => {
    return {
      encryptedPayload,
      captures: savedData,
    };
  };

  return (
    <Main header={header} footer={footer}>
      <Switch>
        <Route
          exact
          path={`${match.url}/privacy`}
          component={() => (
            <Privacy studyId={studyId} policy={config?.policy?.privacy?.items || []} nextStep={config?.policy?.privacy?.nextStep} />
          )}
        />
        <Route exact path={`${match.url}/identification`}>
          <Identification studyId={studyId} onSaveData={handleSaveData} onSaveEncryptedPayload={saveEncryptedPayload} />
        </Route>
        <Route path={`${match.url}/pre-screening`}>
          <PreScreening preScreening={config.preScreening!} studyId={studyId} getPreProcessData={getPreProcessData} />
        </Route>
        <Redirect from="*" to="/404?hr" />
      </Switch>
    </Main>
  );
}
